export const FUENTE_CONTRATO_DEFAULT = 'times-new-roman';

export const FUENTES_CONTRATO = [
  {
    id: 'times-new-roman',
    label: 'Times New Roman',
    stack: '"Times New Roman", Times, serif',
  },
  {
    id: 'arial',
    label: 'Arial',
    stack: 'Arial, Helvetica, sans-serif',
  },
  {
    id: 'calibri',
    label: 'Calibri',
    stack: 'Calibri, Arial, sans-serif',
  },
  {
    id: 'georgia',
    label: 'Georgia',
    stack: 'Georgia, "Times New Roman", serif',
  },
  {
    id: 'garamond',
    label: 'Garamond',
    stack: 'Garamond, "Times New Roman", serif',
  },
  {
    id: 'book-antiqua',
    label: 'Book Antiqua',
    stack: '"Book Antiqua", Palatino, serif',
  },
  {
    id: 'cambria',
    label: 'Cambria',
    stack: 'Cambria, Georgia, serif',
  },
];

const mapaFuentes = FUENTES_CONTRATO.reduce((acc, fuente) => {
  acc[fuente.id] = fuente;
  return acc;
}, {});

export function normalizarFuenteContrato(fuente) {
  const id = String(fuente || '').trim().toLowerCase();
  return mapaFuentes[id] ? id : FUENTE_CONTRATO_DEFAULT;
}

export function resolverStackFuenteContrato(fuente) {
  const id = normalizarFuenteContrato(fuente);
  return mapaFuentes[id].stack;
}

/** Para atributos style en HTML: evita romper comillas con fuentes de varias palabras. */
export function resolverCssFontFamilyContrato(fuente) {
  return resolverStackFuenteContrato(fuente).replace(/"/g, "'");
}

export function obtenerEtiquetaFuenteContrato(fuente) {
  const id = normalizarFuenteContrato(fuente);
  return mapaFuentes[id].label;
}
